import React, { useEffect, useState } from "react";
import CustomAppBar from "../../components/AppBar";
import {
  Container,
  Typography,
  Grid,
  CircularProgress,
  Box,
} from "@mui/material";
import api from "../../globals/axios";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { t } from "i18next";
import CustomCardStatus from "../../components/Custom/CustomCardStatus";

const DEFAULT_LOCATION = {
  latitude: 19.070869,
  longitude: 72.858805,
};

const Warehouses = () => {
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Get user's current location
    const fetchWarehousesWithLocation = async (lat, lng) => {
      try {
        const response = await api.get("/farmer/nearby-service-providers/", {
          params: {
            lat: lat,
            lng: lng,
            service_type: "warehouses", // Filter by warehouse service type
          },
        });

        setWarehouses(response.data.service_providers); // Update based on API structure
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    // Request user's location
    const fetchUserLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            fetchWarehousesWithLocation(latitude, longitude);
          },
          () => {
            // If location access fails, use default location
            fetchWarehousesWithLocation(
              DEFAULT_LOCATION.latitude,
              DEFAULT_LOCATION.longitude
            );
          }
        );
      } else {
        // If geolocation is not supported, use default location
        fetchWarehousesWithLocation(
          DEFAULT_LOCATION.latitude,
          DEFAULT_LOCATION.longitude
        );
      }
    };

    fetchUserLocation();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography variant="h6" color="error">
          {`Error: ${error}`}
        </Typography>
      </Container>
    );
  }

  return (
    <>
      <CustomAppBar />
      <Container>
        <CustomTitle>{t("Nearby Warehouses")}</CustomTitle>
        <Grid container>
          {warehouses.length === 0 ? (
            <Box
              sx={{
                height: "80vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, textAlign: "center" }}
              >
                {t("No Warehouses found nearby.")}
              </Typography>
            </Box>
          ) : (
            <Grid container>
              {warehouses.map((warehouse) => (
                <Grid item xs={12} key={warehouse.id}>
                  <CustomCardStatus
                    title={`${
                      warehouse.owner.name
                    } - ${warehouse.distance.toFixed(2)} ${t("km away")}`}
                    subtitle={`${warehouse.owner.phone} , ${warehouse.owner.address}`}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
};

export default Warehouses;
